import React, { useEffect, useState } from "react";
import Editor from "rich-markdown-editor";
import t from "../../../helpers/t";
import { clientSettingsActions, useSelector } from "inbooma-api";
import { Biscuit } from "../../../../utils";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import Tooltip from "../../../components/Tooltip";

const MessageEdit = (props) => {
  let defaultValue = "";
  if (
    typeof props.client.client_settings !== "undefined" &&
    props.client.client_settings[0].message
  ) {
    defaultValue = props.client.client_settings[0].message;
  }
  const [message, setMessage] = useState(defaultValue);
  const _client = useSelector((state) => state.client_settings_data.editClientSetting);
  const [client, setClient] = useState(props.client.client_settings[0]);
  const [clientPending, setClientPending] = useState(false);

  useEffect(() => {
    if (_client.success === "" || !clientPending) {
      return;
    }
    if (_client.success) {
      setClient(_client.data);
      props.showNotification(
        "success",
        _client.data.id,
        "saved",
        t("saved_${a}", { a: t("message") }),
      );
    } else {
      props.showNotification("warning", null, "saved");
    }
    setClientPending(null);
  }, [_client, clientPending, setClientPending, setClient]);

  const onEditorStateChange = (value) => {
    let val = value();
    setMessage(val);
  };
  const onSubmit = () => {
    let clone = { ...client };
    let val =
      message.replaceAll("\\", "").replaceAll("#", "").replaceAll("*").replaceAll("-", "").trim()
        .length === 0
        ? null
        : message;
    clone.message = val;
    props.dispatch(
      clientSettingsActions.editClientSetting({
        id: clone.id,
        data: clone,
        token: Biscuit.get("token"),
        parameters: {
          headers: {
            "Accept-Language": props.language,
            "Content-Language": props.language,
          },
        },
      }),
    );
    setClientPending(true);
  };

  const close = () => {
    props.closeMessageEdit();
  };

  return (
    <>
      <div id="inb-c-main" className="columns">
        <InboomaSubmenu
          tabs={props.submenuItems}
          searchbar={true}
          searchbarPlaceholder={t("username") + " / ID / " + t("e-mail")}
          searchbarHandler={props.onSearchbarChanged}
          smallOnlyTitle={t("users", null, "capital")}
        />
        <div className="off-canvas-wrapper">
          <div
            className="inb-c-listing off-canvas-content row"
            id="inb-c-main-orders"
            style={{ paddingTop: "47px" }}
          >
            <div className="medium-3"> </div>
            <div id="inb-checkin" className="medium-6">
              <div className="row">
                <div
                  id="inb-checkin-cart"
                  className="medium-12 small-12 large-8"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="content">
                    <fieldset style={{ padding: "10px" }}>
                      <legend>{t("Hinweistext für Kunden")}</legend>
                      <div style={{ border: "1px solid black" }}>
                        <Tooltip
                          tooltip={t("notification_for_markdown")}
                          placement={"bottom"}
                          children={
                            <Editor
                              defaultValue={defaultValue}
                              onChange={onEditorStateChange}
                              placeholder=""
                            />
                          }
                        />
                      </div>
                      {/*<div className='inb-form-group column medium-12 small-12 content'>
                                             <Editor
                                                 onChangeForm={onChangeMessageEditor}
                                                 value={message.content}
                                                 readOnly={isViewMessage}
                                             />
                                             <span className="help-text">{t(formError.content)}</span>
                                         </div>*/}
                      <button
                        type="button"
                        style={{ marginTop: "38px", marginRight: "6px" }}
                        className="inb-round-btn hollow round float-right"
                        title={t("save", null, "capital")}
                        onClick={onSubmit}
                      >
                        {!clientPending && (
                          <>
                            <div
                              className="inb-icon inb-fi-save"
                              style={{ width: "16px", height: "16px", marginLeft: "11px" }}
                            >
                              {" "}
                            </div>
                          </>
                        )}
                        {clientPending && (
                          <span>
                            <img
                              alt="RollingLoader"
                              className="rollingLoader"
                              src={"assets/img/rolling_loader.svg"}
                            />
                            <div
                              className="inb-icon inb-fi-save"
                              style={{ width: "16px", height: "16px", marginLeft: "11px" }}
                            >
                              {" "}
                            </div>
                          </span>
                        )}
                      </button>
                      <button
                        type="button"
                        style={{ marginTop: "38px", marginRight: "6px" }}
                        className="inb-round-btn hollow round float-right"
                        title={t("back", null, "capital")}
                        onClick={() => close()}
                      >
                        <div
                          className="inb-icon inb-fi-arrow-left fi fi-arrow-left"
                          style={{ width: "16px", height: "16px", marginLeft: "11px" }}
                        >
                          {" "}
                        </div>
                      </button>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
            <div className="medium-3"> </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageEdit;
